import React from 'react';
import { Card, Col, CardBody } from 'reactstrap';
import Chat from './Chat';

const ChatCard = () => (
  <Col md={12} lg={12}>
    <Card>
      <CardBody>
        <Chat />
      </CardBody>
    </Card>
  </Col>
);

export default ChatCard;
